<template>
	<div>
		<button @click="changeWidgetSize('small')">small</button>
		<button @click="changeWidgetSize('medium')">medium</button>
		<button @click="changeWidgetSize('large')">large</button>
		<button @click="handleRemove">删除</button>
		<button @click="handleExport">导出</button>
		<component :is="rootWidget.type" :me="rootWidget" />
	</div>
</template>

<script lang="ts">
import { defineComponent, inject } from 'vue';
import {
	dataKey,
	ListWidget,
	State,
	Widget,
	WidgetDate,
	WidgetImage,
	WidgetSpacer,
	WidgetStack,
	WidgetText,
	widgetType,
} from '../types';
import apportion from '../util/apportion';
import genRenderJS from '../util/genRenderJS';

export default defineComponent({
	setup() {
		// 默认插入根组件
		const state: State = inject<any>(dataKey.STATE);
		const rootWidget = state.rootWidget as ListWidget;

		// 改变组件大小
		const changeWidgetSize = (type: string) => {
			const sizes: any = {
				small: {
					width: 149,
					height: 149,
				},
				medium: {
					width: 320,
					height: 149,
				},
				large: {
					width: 320,
					height: 320,
				},
			};
			rootWidget.size.width = sizes[type].width;
			rootWidget.size.height = sizes[type].height;
			apportion(rootWidget);
		};

		// 移除选中的Node
		const removeNode = (widget: ListWidget | WidgetStack) => {
			const targetID = state.curWidget.id;
			widget.realNodes.forEach((node, index, array) => {
				if (node.id === targetID) {
					array.splice(index, 1);
					return;
				}
				if (node.type === widgetType.STACK) {
					removeNode(node as WidgetStack);
				}
			});
		};
		const handleRemove = () => {
			removeNode(rootWidget);
			state.curWidget = rootWidget;
		};

		// 导出widget
		const pruneAndCopy = (widget: Widget) => {
			const ast: any = {};
			const tagNameMap = {
				ListWidget: 'widget',
				WidgetDate: 'date',
				WidgetImage: 'image',
				WidgetSpacer: 'spacer',
				WidgetStack: 'stack',
				WidgetText: 'text',
			};
			ast.tagName = tagNameMap[widget.type];
			ast.attrs = widget.attrs;
			if (widget.type === widgetType.LIST || widget.type === widgetType.STACK) {
				const me = widget as ListWidget | WidgetStack;
				ast.children = me.realNodes.map(node => pruneAndCopy(node));
				ast.attrs.bgImageDate = me.bgImageDate;
				return ast;
			}
			if (widget.type === widgetType.DATE || widget.type === widgetType.IMAGE) {
				const me = widget as WidgetImage;
				ast.children = [me.rawImageDate.slice(22)];
				return ast;
			}
			if (widget.type === widgetType.TEXT) {
				const me = widget as WidgetText;
				ast.children = [me.attrs.text];
				return ast;
			}
			if (widget.type === widgetType.SPACER) {
				const me = widget as WidgetSpacer;
				ast.children = [me.attrs.length];
				return ast;
			}
		};
		const handleExport = () => {
			const ast = pruneAndCopy(rootWidget);
			const fileName = 'render.js';
			const content = genRenderJS(JSON.stringify(ast));
			const a = document.createElement('a');
			a.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
			a.setAttribute('download', fileName);
			a.style.display = 'none';
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
		};

		return { rootWidget, changeWidgetSize, handleRemove, handleExport };
	},
});
</script>

<style scoped></style>
